import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import DashboardCharts from "./DashboardCharts";
import { getOverallCounts } from "../Apis/DashboardAPIs";
import { getClientGroups } from "../Apis/ClientGroupAPIs";

const DashBoardLayerEight = () => {
    const [counts, setCounts] = React.useState({
        future: 0,
        present: 0,
        past: 0,
        employees: 0,
        products: 0,
        clients: 0,
        managers: 0,
        groupCount: 0,
        presentStalls: { total: 0, booked: 0, available: 0 },
        presentVisitors: { total: 0, booked: 0, available: 0 },
        todayFollowups: 0
    });

    React.useEffect(() => {
        const fetchCounts = async () => {
            try {
                let groupCountVal = 0;
                try {
                    const groupRes = await getClientGroups({ page: 0, limit: 1 });
                    if (groupRes.status && groupRes.response) {
                        groupCountVal = groupRes.response.total || 0;
                    }
                } catch (groupErr) {
                    console.error("Error fetching group count:", groupErr);
                }

                const res = await getOverallCounts();
                if (res.status && res.response.success) {
                    const data = res.response.data;
                    setCounts({
                        future: data.upcomingCount || 0,
                        present: data.presentCount || 0,
                        past: data.pastCount || 0,
                        employees: data.managerCount || 0,
                        products: 0, // Not provided by this endpoint
                        clients: data.clientCount || 0,
                        managers: data.managerCount || 0,
                        groupCount: groupCountVal || data.groupCount || data.clientGroupCount || 0,
                        presentStalls: {
                            total: data.stallDetails?.total || 0,
                            booked: data.stallDetails?.booked || 0,
                            available: data.stallDetails?.available || 0
                        },
                        presentVisitors: {
                            total: data.visitorDetails?.total || 0,
                            booked: data.visitorDetails?.booked || 0,
                            available: data.visitorDetails?.available || 0
                        },
                        todayFollowups: data.todayFollowups || 0
                    });
                } else {
                    setCounts(prev => ({
                        ...prev,
                        groupCount: groupCountVal
                    }));
                }
            } catch (error) {
                console.error("Error fetching dashboard counts:", error);
            }
        };

        fetchCounts();
    }, []);

    const stats = [
        // {
        //     title: "UPCOMING EXPO",
        //     value: counts.future,
        //     link: "/upcoming-expo",
        //     bgColor: "bg-primary-50",
        //     icon: "solar:calendar-date-bold",
        //     iconColor: "text-primary-600"
        // },
        {
            title: "CURRENT EXPOS",
            value: counts.present,
            link: "/present-expo",
            bgColor: "bg-success-50",
            icon: "solar:calendar-mark-bold",
            iconColor: "text-success-600"
        },
        {
            title: "PAST EXPOS",
            value: counts.past,
            link: "/past-expo",
            bgColor: "bg-info-50",
            icon: "solar:calendar-search-bold",
            iconColor: "text-info-600"
        },
        // {
        //     title: "PRESENT EXPO STALL",
        //     value: `${counts.presentStalls.booked} / ${counts.presentStalls.total}`,
        //     subtitle: `${counts.presentStalls.available} Available`,
        //     link: "/present-expo",
        //     bgColor: "bg-warning-50",
        //     icon: "solar:box-minimalistic-bold",
        //     iconColor: "text-warning-600"
        // },
        // {
        //     title: "PRESENT EXPO VISITOR",
        //     value: `${counts.presentVisitors.booked} / ${counts.presentVisitors.total}`,
        //     subtitle: `${counts.presentVisitors.available} Slots Left`,
        //     link: "/visitor-booking-list",
        //     bgColor: "bg-success-50",
        //     icon: "solar:users-group-rounded-bold",
        //     iconColor: "text-success-600"
        // },
        {
            title: "TODAY FOLLOWUPS",
            value: counts.todayFollowups,
            link: "/today-followup",
            bgColor: "bg-info-50",
            icon: "solar:bell-bold",
            iconColor: "text-info-600"
        },
        {
            title: "MANAGERS",
            value: counts.employees,
            link: "/employees",
            bgColor: "bg-warning-50",
            icon: "solar:users-group-two-rounded-bold",
            iconColor: "text-warning-600"
        },
        {
            title: "EXHIBITORS",
            value: counts.clients,
            link: "/client-groups",
            bgColor: "bg-danger-50",
            icon: "solar:shield-user-bold",
            iconColor: "text-danger-600"
        },
        {
            title: "GROUPS",
            value: counts.groupCount,
            link: "/client-groups",
            bgColor: "bg-primary-50",
            icon: "solar:users-group-rounded-bold",
            iconColor: "text-primary-600"
        },
    ];

    return (
        <div className="dashboard-main-body">
            {/* Stats Grid */}
            <div className="row gy-4 mb-24">
                {stats.map((stat, index) => {
                    const CardWrapper = stat.noLink ? 'div' : Link;
                    const wrapperProps = stat.noLink ? { className: "text-decoration-none d-block h-100 cursor-default" } : { to: stat.link, className: "text-decoration-none d-block h-100" };

                    return (
                        <div className="col-xl-4 col-lg-4 col-sm-6" key={index}>
                            <CardWrapper {...wrapperProps}>
                                <div
                                    className="card radius-8 border-0 shadow-sm h-100 position-relative overflow-hidden bg-white card-hover-gradient"
                                    style={{ minHeight: '120px' }}
                                >
                                    {/* Gradient Right Border overlay */}
                                    <div
                                        className="position-absolute end-0 top-0 bottom-0 gradient-border-overlay"
                                        style={{ width: '6px', background: 'linear-gradient(to bottom, #000000, #ed1c24)', transition: 'opacity 0.3s ease' }}
                                    ></div>

                                    {/* Content */}
                                    <div className="card-body p-20 d-flex flex-column justify-content-between h-100">
                                        <span className="text-secondary-light fw-bold text-sm mb-16 d-block uppercase tracking-wider text-truncate" style={{ letterSpacing: "1px" }}>
                                            {stat.title}
                                        </span>

                                        <div className="d-flex align-items-end justify-content-between mt-auto">
                                            <div>
                                                <h6 className="mb-0 fw-bolder text-dark" style={{ fontSize: "28px" }}>
                                                    {stat.value}
                                                </h6>
                                                {stat.subtitle && (
                                                    <div className="text-secondary-light text-xxs mt-4 fw-medium" style={{ letterSpacing: '0.5px' }}>
                                                        {stat.subtitle}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-center align-items-center mb-1">
                                                <Icon icon={stat.icon} className="text-secondary-light" style={{ fontSize: "24px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardWrapper>
                        </div>
                    );
                })}
            </div>

            {/* Reporting Charts */}
            <DashboardCharts />
        </div>
    );
};

export default DashBoardLayerEight;
